'use client';

import { ProductCard } from '@/components/product-card';
import type { ProductCardProps } from '@/lib/types';
import { CustomLink } from '@veranda/shared/components/custom-link';
import { ModuleWrapper } from '@veranda/shared/components/module-wrapper';
import { ProductListing } from '@veranda/shared/components/modules';
import type { HomePageProps } from '@veranda/shared/components/pages/home/client';
import { ArrowRight } from 'lucide-react';

type Props = Extract<
  NonNullable<HomePageProps['modules']>[number],
  { moduleType: 'productListingModule' }
>;

export function ProductListingModule({ data }: { data: Props }) {
  if (!data) return null;

  return (
    <ModuleWrapper
      topPadding={data.moduleSettings?.topPadding}
      bottomPadding={data.moduleSettings?.bottomPadding}
      colorTheme={data.colorTheme}
    >
      <ProductListing>
        <ProductListing.Header>
          {data.title && (
            <h2 className="typography-clash-h3 font-medium text-brand-burgundy">
              {data.title}
            </h2>
          )}

          {data.link && (
            <CustomLink
              href={data.link.slug || ''}
              target={data.link.openInNewTab ? '_blank' : undefined}
              className="flex items-center gap-1 font-medium hf:underline"
            >
              {data.link.text}
              <ArrowRight className="size-4" />
            </CustomLink>
          )}
        </ProductListing.Header>
        <ProductListing.Items>
          {data.products?.map((product, index) => {
            if (!product) return null;
            return (
              <ProductListing.Item key={product.slug + index}>
                <ProductCard
                  product={product as ProductCardProps}
                  index={index}
                />
              </ProductListing.Item>
            );
          })}
        </ProductListing.Items>
        <ProductListing.Footer />
      </ProductListing>
    </ModuleWrapper>
  );
}
